import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import TagSelector from '@/components/TagSelector';
import useProfileOptions from '@/hooks/useProfileOptions';

export default function NetworkingTab({ profile, set, handleSave }) {
  const opts = useProfileOptions();
  return (
    <>
      <Card className="p-8 border border-slate-200 mb-6">
        <h2 className="text-lg font-bold font-heading mb-1">Networking Preferences</h2>
        <p className="text-sm text-slate-500 mb-6">These fields power your smart networking recommendations</p>
        <div className="space-y-6">
          <TagSelector label="Looking For" options={opts.looking_for} selected={profile.looking_for}
            onChange={(v) => set('looking_for', v)} testId="add-looking-for-btn" max={4} />
          <TagSelector label="Active Projects" options={opts.projects} selected={profile.projects}
            onChange={(v) => set('projects', v)} testId="add-projects-btn" max={4} />
          <TagSelector label="Sustainability Goals" options={opts.sustainability_goals} selected={profile.sustainability_goals}
            onChange={(v) => set('sustainability_goals', v)} testId="add-goals-btn" max={4} />
          <div>
            <Label htmlFor="working_on">What I'm Currently Working On</Label>
            <Textarea id="working_on" data-testid="profile-working-on-textarea" placeholder="Describe your current focus areas or projects..."
              value={profile.working_on} onChange={(e) => set('working_on', e.target.value)} className="mt-1.5 min-h-20" />
          </div>
        </div>
      </Card>

      <Button data-testid="save-networking-button" onClick={handleSave}
        className="w-full h-12 text-base bg-gradient-to-r from-brand-navy to-brand-sage hover:from-brand-dark hover:to-brand-sage text-white">
        Save Changes
      </Button>
    </>
  );
}
